import { HIDE_APP_OFFLINE_STATUS_BAR } from './appTypes';

export const hideOfflineStatusBar = () => (dispatch) =>
  dispatch({ type: HIDE_APP_OFFLINE_STATUS_BAR });
